<app-loader *ngIf="showLoader"></app-loader>
<!-- <div class="modal-dialog"> -->
<div>
    <div class="modal-content">  
      <div class="modal-header">
        <h3 class="modalHeader">
          {{ logHeading }}: {{correlation_ID}}
        </h3>
      </div>      
      <!-- <div style="height: 500px; overflow-y: auto" *ngIf="!noLogs">
         <div *ngFor="let stage of processStages; let i = index">
            <div class="form-group" style="margin-left: 10px; margin-top: 10px;">
                <p><b>{{ i + 1 }}) {{ stage }}</b></p>
            </div>
            <div *ngFor="let log of filteredLogList(stage)">
              <div class="form-group" style="margin-left: 15px;">            
                  <p><span>{{ log.messagetype }}:</span> {{ log.message }}</p>
                  <p>{{ log.logtime }}</p>
              </div>  
            </div>  
          </div>        
      </div> style="width:55%;float:right;border-left: #eee solid 2px;min-height:600px;padding-left:30px;" -->
      <div style="height: 350px; overflow-y: auto" *ngIf="!noLogs">
        <table class="table table-bordered table-hover">    
          <tbody>
            <tr style="background-color:#F9f9f9;">
              <th style="width: 150px;">
                <div class="center"><b>Process Stage</b></div>
              </th>
              <th>
                <div class="center"><b>Message</b></div>
              </th>
              <th style="width: 175px;">
                <div class="center"><b>Log Time</b></div>
              </th>
            </tr>
          </tbody>
          <tbody style="text-align:center;">    
            <tr *ngFor="let item of logList; let i = index">    
              <td>
                {{ i+1 }}) {{ item.processstage }}
              </td>
              <td>
                <span><img title="SUCCESS" *ngIf="item.messagetype == 'SUCCESS'" src="../../assets/static/success-icon.png"></span>
                <span><img title="ERROR" *ngIf="item.messagetype == 'ERROR'" src="../../assets/static/error-icon.png"></span>
                {{ item.message }}
              </td>  
              <td>
                {{ item.logtime }}
              </td>
            </tr>    
          </tbody>   
        </table>
      </div>
      <div *ngIf="noLogs" style="margin: 15px;">No logs to display</div>
      <div class="modal-footer">
        <div class="form-group">
          <button class="btn btn-primary" (click)="invokeFetchLogsAPI()">Refresh</button>
          <button type="button" class="btn btn-default " data-dismiss="modal" (click)="closeModal()">Close</button>
        </div>
      </div>
    </div>
</div>
<!-- </div> -->